import React from 'react';
import { Button, Modal } from 'react-bootstrap';

export const LeaveFeedbackModal = ({
  showModal,
  feedback,
  handleFeedback,
  feedbackError,
  disabled,
  postFeedback,
  setFeedbackError,
  setShowModal,
}) => {
  return (
    <>
      <Modal show={showModal} backdrop="static" centered dialogClassName="property-modal">
        <Modal.Header
        title="hola"
          closeButton
          onClick={() => {
            setFeedbackError(null);
            setShowModal(false);
          }}
        >
          <Modal.Title><span className='font-weight-bold'>Property Feedback</span></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label className="form-label mb-2 mt-2" htmlFor="feedback">
            Feedback:
          </label>
          <textarea
            id="feedback"
            autoComplete="off"
            className={`form-control d-block w-100`}
            type="text"
            value={feedback}
            onChange={handleFeedback}
            name="feedback"
            required
          />
          {feedbackError && (
            <small className="text-danger">{feedbackError}</small>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            className="property-primary-btn"
            onClick={(event) => postFeedback(event)}
            disabled={feedback !== null && disabled === true}
          >
            {feedback !== null && disabled === true
              ? 'Adding...'
              : 'Add'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
